import { useQuery } from "@tanstack/react-query";
import { fetchAllInsights, fetchInsightReports } from "@/services/DataService";

export const useInsights = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["insights"],
    queryFn: fetchAllInsights,
    enabled: options?.enabled ?? true,
  });
};

export const useInsightReports = (insightId: string, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ["insightReports", insightId],
    queryFn: () => fetchInsightReports(insightId),
    enabled: options?.enabled ?? true,
  });
};
